//-------------------------------------------------------------------------
// Temporary custom TabPanel pending proper re-factoring of application theme
//-------------------------------------------------------------------------

// TODO: Move these styling changes to a global theme override (affecting
//       MuiTab) so that the standard Tab class will be properly
//       themed with Nuvoola's theme.
// TODO: Once the above is done:
//       - Replace all instances of NuvTab with Tab.
//       - Delete this file.

import { withStyles } from "@material-ui/styles";
import TabPanel from "@material-ui/lab/TabPanel";
import colors from "../../assets/style/colors";

const NuvTabPanel = withStyles((theme) => ({
    root: {
        padding: 0,
        border: "1px solid",
        borderColor: colors.black20,
    },
}))(TabPanel);

export default NuvTabPanel;